export const modeDetail = {
  VIEW: "VIEW",
  CREATE: "CREATE",
  EDIT: "EDIT",
};
